export default __webpack_public_path__ + "static/media/arrow.4b8a8db5.svg";